import React from "react";
import StarRateIcon from "@material-ui/icons/StarRate";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import ArchivedChip from "common_components/project/archived_project_chip";
import {PlaybookIssueset} from "common/types/issueset";

interface IssuesetItemProps {
  issueset: PlaybookIssueset;
  templateIssueset: PlaybookIssueset | null;
  isSelected: boolean;
  onSelectIssueset: () => void;
  onStarIssueset: () => void;
  isAdmin: boolean;
}

const IssuesetItem: React.FC<IssuesetItemProps> = ({
  issueset,
  templateIssueset,
  isSelected,
  onSelectIssueset,
  onStarIssueset,
  isAdmin,
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const onHoverStart = () => setIsHovered(true);
  const onHoverFinish = () => setIsHovered(false);
  const onStarClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onStarIssueset();
  };

  const StarIcon = issueset.is_star
    ? StarRateIcon
    : isHovered
    ? StarBorderIcon
    : null;

  return (
    <div
      className="issuesetItem"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1rem",
        border: "1px solid #777",
        ...(isSelected ? {backgroundColor: "#eef"} : {}),
        cursor: "pointer",
      }}
      onClick={onSelectIssueset}
      onMouseEnter={onHoverStart}
      onMouseLeave={onHoverFinish}
    >
      <div style={{display: "flex", alignItems: "center"}}>
        <div
          style={
            issueset.is_archived || issueset.is_hidden ? {opacity: 0.4} : {}
          }
        >
          {issueset.remote_client_id && templateIssueset
            ? templateIssueset.name
            : issueset.name}
          {issueset.remote_client_name && ` (${issueset.remote_client_name})`}
        </div>
        {issueset.is_archived && <ArchivedChip />}
        {isAdmin && issueset.is_hot && (
          <WhatshotIcon style={{height: 18, width: 18, color: "#ef5350"}} />
        )}
      </div>
      {StarIcon ? (
        <StarIcon
          onClick={onStarClick}
          style={{height: 26, width: 26, color: "#fbc02d"}}
        />
      ) : (
        <div style={{width: 26, height: 26}} />
      )}
    </div>
  );
};

export default IssuesetItem;
